/** Reserved synthetic tab ids (not documents rows). */
export const EDIT_HISTORY_TAB_ID = 'edit-history' as const

/** Legacy id before dedicated tab type + /edit-history route */
export const LEGACY_EDIT_HISTORY_TAB_ID = 'view:edit-history' as const

/** Canonical Activity / All edits surface (Search named view). */
export const SEARCH_ACTIVITY_PATH = '/search?view=activity' as const

export function isEditHistoryTabId(tabId: string | null | undefined): boolean {
  return tabId === EDIT_HISTORY_TAB_ID || tabId === LEGACY_EDIT_HISTORY_TAB_ID
}

export function normalizeEditHistoryTabId(tabId: string): string {
  return tabId === LEGACY_EDIT_HISTORY_TAB_ID ? EDIT_HISTORY_TAB_ID : tabId
}

export const SEARCH_VIEW_TAB_ID = 'search-view' as const

export function isSearchViewTabId(tabId: string | null | undefined): boolean {
  return tabId === SEARCH_VIEW_TAB_ID
}

/** Open Search tab focused on Activity / All edits. */
export function dispatchOpenSearchActivity() {
  window.dispatchEvent(
    new CustomEvent('flownotes:open-search-view', {
      detail: { query: '', view: 'activity' },
    }),
  )
}
